import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMenu } from "../../store/slices/menuSlice";

import ServiceCurrencyExchangePage from "../ServiceCurrencyExchange";
import ValueAddedServicesPage from "../ValueAddedServices";
import UsratiPage from "../Usrati";
import BuyBackGuaranteePage from "../BuyBackGuarantee";
import BulkCashDepartmentPage from "../BulkCashDepartment";
import RetailMoneyTransferPage from "../RetailMoneyTransfer";
import CorporateMoneyTransferPage from "../CorporateMoneyTransfer";
import ErrorPage from "../Error";
import CommonServicePage from "../CommonServicePage";
import CommonServiceInnerPage from "../CommonServiceInnerPage";
import { useTranslation } from "react-i18next";

const OtherService = () => {
  const { commonSlug } = useParams();
  const { t } = useTranslation(["common"]);
  const dispatch = useDispatch();
  const menuData = useSelector((state) => state.menu);

  const pageService = useSelector((state) => state.pageService);

  useEffect(() => {
    if (menuData.status === "idle") {
      menuHeader();
    }
  }, []);
  if (pageService?.status == "succeeded" && !pageService?.isPageExist) {
    return <ErrorPage />;
  }

  const menuHeader = async () => {
    await dispatch(getMenu());
  };

  const checkComponent = (commonSlug) => {



   const template= pageService?.[commonSlug]?.details?.[0]?.template_type

    switch (template) {
      case "c-exchange":
        return <ServiceCurrencyExchangePage />;
      case "v-added-services":
        return <ValueAddedServicesPage />;
      case "ustrati":
        return <UsratiPage />;
      case "buy-back-guarantee":
        return <BuyBackGuaranteePage />;
      case "bcd":
        return <BulkCashDepartmentPage />;
      case "rt-money-transfer":
        return <RetailMoneyTransferPage />;
      case "c-money-transfer":
        return <CorporateMoneyTransferPage />;
      case "c-r-p":
        return <CommonServicePage />;

      default:
        return template === undefined ? (
          <CommonServicePage />
        ) : (
          <CommonServiceInnerPage />
        );
    }
  };

  return checkComponent(commonSlug);
};

export default OtherService;
